const successMsgs = {
  changePassword: "Password is changed successfully",
  deletedSuccessfully: "Deleted successfully ",
  addedSuccessfully: "Added successfully",
  eventDeletedSuccessfully: "Event deleted successfully",
  eventCanceledSuccessfully: "Event cancelled successfully",
  approveRequest: "The request has been approved successfully",
  updatedSuccessfully: "Updated successfully",
  acceptRequest: "Request accepted successfully",
  rejectRequest: "Request rejected",
  forgetPassword: " New password is sent to your email ",
  blockedSuccessfully: "The user has been blocked successfully",
  unBlockedSuccessfully: "The user has been unblocked successfully",
  applicantsInvitedSuccessfully: "Applicants have been invited successfully",
  companyActivated: "Company has been activated successfully",
  companyDeactivated: "Company has been deactivated successfully",
  companyUpdatedSuccessfully: "Company profile updated successfully",
  companyEditRequestApproved: "Profile update request approved successfully",
  companyEditRequestRejected: "Profile update request rejected",
  eventPublishedSuccessfully:
    "The event has been published successfully",
  eventUpdatedSuccessfully: "The event has been updated successfully",
};

export default successMsgs;
